module.exports = __webpack_public_path__ + "static/media/A18040103_10003_2.e4807638.jpg";